import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5316dd0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["dsf_href"]
const _hoisted_2 = ["dsf_href"]

import PrivacyPolicyLink from '@/components/PrivacyPolicyLink.vue'
import ImprintLink from '@/components/ImprintLink.vue'
import CookieLink from '@/components/CookieLink.vue'
import { useSennderLanguageUrl } from '@/components/sennderUrlHelper'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayoutFooter',
  props: {
  isMobileLayout: { type: Boolean, required: true },
},
  setup(__props) {



const termsConditionsUrl = useSennderLanguageUrl('terms-conditions/carrier')
const participationAndUseUrl = useSennderLanguageUrl('orcas/terms-conditions')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["footer flex h-35 border-t-1 border-neutral-100 py-8 items-center gap-16 justify-center", [{ 'footer-mobile': __props.isMobileLayout }]])
  }, [
    _createElementVNode("dsf-link", {
      dsf_size: "medium",
      dsf_href: _unref(termsConditionsUrl),
      target: "_blank"
    }, _toDisplayString(_ctx.$t('registration.termsAndConditionsLabel')), 9 /* TEXT, PROPS */, _hoisted_1),
    _createElementVNode("dsf-link", {
      dsf_size: "medium",
      dsf_href: _unref(participationAndUseUrl),
      target: "_blank"
    }, _toDisplayString(_ctx.$t('registration.participationAndUseLabel')), 9 /* TEXT, PROPS */, _hoisted_2),
    _createVNode(PrivacyPolicyLink),
    _createVNode(ImprintLink),
    _createVNode(CookieLink)
  ], 2 /* CLASS */))
}
}

})